import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import confirmDelete from '../ConfirmDelete';
import getEncodedImageUrl from "../../helpers/getEncodedImageUrl";
import ImgToolTip from '../ImgTooltip';

const TypeRow = ({ id, name, icon, deleteFn, intl }) => {
  const delText = intl.formatMessage({ id: 'confirm.s.type-delete' })

  return (
    <div className="added-event-container">
      <div className="e-name-container">
        <div className="e-name">
          <div className="event-icon-container">
            {icon ? (
              <img className="event-icon rounded-circle" src={getEncodedImageUrl(icon, 85, 85)} alt="" />
            ) : (
                <img
                  className="event-icon rounded-circle"
                  src={`https://ui-avatars.com/api/?name=${name}&size=85&color=ff7142`}
                  alt=""
                />
              )}
          </div>
          <div className="m-l-45 justify-content-center">
            <h6>
              {name}
            </h6>
          </div>
        </div>
        <div className="del-event-container justify-content-center">
          <Button
            onClick={() => {
              confirmDelete(intl, id, undefined, ('type', _id => (
                deleteFn('type', _id)
              )), delText);
            }}
          >
            <ImgToolTip className="icon-normal" intl={intl} placement="left" tooltiptext={`action.delete-type`} id="tooltip-download-latest" img={`/icons/delete.png`} />
            <ImgToolTip className="icon-hover" intl={intl} placement="left" tooltiptext={`action.delete-type`} id="tooltip-download-latest-hover" img={`/icons/delete-hover.png`} />
            <ImgToolTip className="icon-focus" intl={intl} placement="left" tooltiptext={`action.delete-type`} id="tooltip-download-latest-focus" img={`/icons/delete-focus.png`} />
          </Button>
        </div>
      </div>
      <Link className="d-flex w-10" to={`/type/edit/${id}`}>
        <Button className="btn-return">{intl.formatMessage({ id: 'button.s.type-update' })}</Button>
      </Link>
    </div>
  );
};

export default injectIntl(TypeRow);
